import React from 'react';

interface SummarySectionWithTitleProps {
	title: string;
	teamName?: string;
	children?: React.ReactNode;
	className?: string;
}

export const SummarySectionWithTitle = ({ title, children, className = '' }: SummarySectionWithTitleProps) => {
	return (
		<div className={`mt-4 w-full rounded-[8px] border border-gray-200 ${className}`}>
			<p className="rounded-t-[8px] bg-purple-50 p-4">{title}</p>
			{children && <div className="p-4">{children}</div>}

			{/* In the future, this section can be extended to include a table for payment details, such as itemized costs, quantities, and totals */}
		</div>
	);
};
